import React from "react";

const PollAnswer = (props) => {
    let barStyle;

    if (props.hasCount) {
        barStyle = {width: `${props.percentage}%`};
    } else {
        barStyle = {width: '0%'};
    }

    return (
      <div className="poll-answer">
        <div className="progress-wrapper" onClick={() => props.onClick()}>
          <div className="progress">
            <div className="progress-bar" role="progressbar" style={barStyle} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <div className="answer-text">{props.text}</div>
          <a className="login-message" href="/pages/perfil/">Inicia Sesión</a>
        </div>
        {props.hasCount &&
            <div className="progress-label">
                {props.percentage.toFixed(2)}% de las personas que han votado
            </div>
        }
      </div>
    );
};

export default PollAnswer;
